import type { WhatsNewBody } from '../types';

export default {
  title: 'A Contacts tab on every job',
  summary:
    'Each job now has a Contacts tab: our team at the top, then everyone else by their role on the job. People and companies live in one shared address book, so a correction shows on every job they are on.',
  details: [
    'Job editors add someone by picking from the address book first, so the same person is not typed twice.',
    'Remove takes someone off this job only.',
  ],
  tryIt: { to: '/projects', label: 'Open Projects' },
  guide: { topic: 'mod-contacts-who' },
} satisfies WhatsNewBody;
